import React, { useContext, useEffect, useRef, useState } from "react";

import { useMediaQuery } from "react-responsive";

import { isXsQuery } from "@/components/layout/Media";
import { PageSizeContext } from "@/components/layout/PageSize";
import { ScrollParent } from "@/components/layout/ScrollParent";

import { SERVICE_DETAILS_VERTICAL_MARGIN } from "./constants";

interface ChildProps {
  height: string;
}

interface ModalContainerProps {
  children: React.ReactElement<ChildProps>;
}

export function ModalContainer({ children }: ModalContainerProps) {
  const { windowHeight } = useContext(PageSizeContext);
  const [minHeight, setMinHeight] = useState("100vh");
  const [currentTop, setCurrentTop] = useState(100);
  const isXs = useMediaQuery(isXsQuery);
  const verticalOffset = isXs ? 0 : SERVICE_DETAILS_VERTICAL_MARGIN * 2;

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const modalContentRef = useRef<HTMLDivElement>(null);

  const clear = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };
  useEffect(() => {
    clear();
    intervalRef.current = setInterval(() => {
      if (modalContentRef.current) {
        const currentTop = modalContentRef.current.getBoundingClientRect().top;
        setMinHeight(`${windowHeight - currentTop - verticalOffset}px`);
        setCurrentTop(currentTop);
        clear();
      }
    }, 100);
    return clear;
  }, [windowHeight]);

  return (
    <div ref={modalContentRef}>
      <ScrollParent heightOffset={verticalOffset + currentTop}>
        {React.isValidElement(children) &&
          React.cloneElement(children, { height: minHeight })}
      </ScrollParent>
    </div>
  );
}
